import axios from 'axios';
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import AdminLayout from '../Componets/AdminLayout';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';

export default function Report() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  // State variables
  const [records, setRecords] = useState([]); // Faculty report records
  const [searchTerm, setSearchTerm] = useState(''); // Search term
  const [loading, setLoading] = useState(false); // Loading state
  // const [overallTotals, setOverallTotals] = useState({}); // Overall totals
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const location = useLocation();
  const { subjectId, examId, subjectName } = location.state || {};
  const overallTotals = {
    TotalFaculty: 100,
    PENDING: 20,
    INPROGRESS: 40,
    COMPLETED: 30,
    TotalCount: 90,
  };

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }
  }, [navigate]);

  useEffect(() => {
    fetchFacultyReport();
  }, []);

  // Function to fetch faculty report data
  const fetchFacultyReport = async () => {
    setLoading(true);
    const token = localStorage.getItem('token');
    const data = {
      examId: examId,
      subjectId: subjectId,
    };

    try {
      const response = await axios.post(
        `${apiUrl}/api/answersheet/faculty-report`,
        data,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );
      setRecords(response.data.data || []);
      // setOverallTotals(response.data.overallTotals || {});
      setLoading(false);
    } catch (error) {
      console.error('Error fetching faculty report:', error);
      setLoading(false);
      if (error.response?.status === 401) navigate('/');
    }
  };

  // Columns configuration for DataTable
  const columns = [
    {
      name: 'No',
      selector: (row, index) => {
        // Calculate serial number based on current page and rows per page
        return (currentPage - 1) * rowsPerPage + index + 1;
      },
      width: '50px',
      center: 'true',
    },
    {
      name: 'Faculty Name',
      selector: (row) => row.facultyName,
      sortable: true,
    },
    {
      name: 'Total Count',
      selector: (row) => row.totalCount,
      center: 'true',
    },
    {
      name: 'Status Counts',
      cell: (row) => (
        <div className="d-flex align-items-center ">
          <span className=" fs-6  badge rounded-pill bg-secondary text-white ">
            {row.PENDING}
          </span>
          <span className="  fs-6 mx-2 badge rounded-pill bg-warning text-dark ">
            {row.INPROGRESS}
          </span>
          <span className="  fs-6 badge rounded-pill bg-success text-white ">
            {row.COMPLETED}
          </span>
        </div>
      ),
      width: '150px',
      center: 'true',
    },
    {
      name: 'Details',
      width: '90px',
      center: 'true',
      cell: (row) => (
        <div>
          <button
            className="btn btn-primary btn-sm "
            onClick={() =>
              navigate('/ReportData', {
                state: {
                  facultyName: row.facultyName,
                  subjectId: subjectId,
                  examId: examId,
                },
              })
            }
            data-tooltip-id="my-tooltip"
            data-tooltip-content="View Faculty Details"
          >
            <i className="bi bi-qr-code"></i>
          </button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <main id="main" className="main">
        <AdminLayout ac11="active">
          <div className="pagetitle">
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/AdminHome">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/ReportDashbord">Report Exams</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/ReportExam" state={{ examId: examId }}>
                    Report Subjects
                  </Link>
                </li>

                <li className="breadcrumb-item active">
                  View Faculty Report ({overallTotals?.TotalFaculty || 0})
                </li>
              </ol>
            </nav>
          </div>

          <hr className="mb-0" />
          <div className="row">
            <div className="container">
              <div className="datatable-top">
                <div className="datatable-search">
                  <input
                    className="form-control"
                    type="search"
                    placeholder="Faculty Name"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
                <div className="d-flex align-items-center  mt-3  ">
                  <span className="   badge rounded-pill bg-secondary   ">
                    Panding
                  </span>
                  <span
                    className="  mx-2 badge rounded-pill bg-warning   "
                    style={{ color: 'black' }}
                  >
                    In Progress
                  </span>
                  <span className="  badge rounded-pill bg-success  ">
                    Completed
                  </span>
                </div>
              </div>
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={records.filter((record) =>
                    record.facultyName
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase())
                  )}
                  progressPending={loading}
                  pagination
                  className="custom-table"
                  paginationPerPage={rowsPerPage} // Set rows per page
                  paginationTotalRows={records.length} // Total number of records
                  paginationDefaultPage={currentPage} // Default starting page
                  onChangePage={(page) => setCurrentPage(page)} // Update current page
                  onChangeRowsPerPage={(newPerPage) =>
                    setRowsPerPage(newPerPage)
                  } // Update rows per page
                />
                <ToastContainer
                  position="top-center"
                  style={{ width: 'auto' }}
                />
              </div>
            </div>
          </div>
        </AdminLayout>
        <Tooltip id="my-tooltip" />
      </main>
    </div>
  );
}
